module.exports = __webpack_public_path__ + "img/logo_tit@2x.85eae5e6.png";